/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcDesktopIcon24Solid = forwardRef('TechPcDesktopIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10 4.5A2.5 2.5 0 0 1 12.5 2h8A2.5 2.5 0 0 1 23 4.5v15a2.5 2.5 0 0 1-2.5 2.5h-5.208a2.491 2.491 0 0 0 .134-1.608A4.002 4.002 0 0 0 18.5 16.5v-7a4 4 0 0 0-4-4H10v-1Z" }),
        React.createElement("path", { d: "M4 7a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h3v1H5a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-2v-1h3a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3H4Z" })));
});
